<template>
  <Drawer class="template-list"
    title="选择保函模板"
    @on-close="closeDrawer"
    :closable="true"
    :scrollable="true"
    width="400"
    v-model="showDrawer">
    <div style="width:160px"
      class="template-item"
      :class="{cur:curTemplate===template}"
      @click="cursorTemplate(template)"
      v-for="(template,idx) in data"
      :key="idx">
      <!-- <div style="text-align:center">
        <iframe width="140" height="140" frameborder="0" :id="`tplPreview-${idx}`" v-html="template.template"></iframe>
      </div> -->
      <div style="text-align:center">
        <h2>{{template.name}}</h2>
        <div class="font-grey small">
          品种: {{template.varietyName}}<br>
          创建日期: {{require('moment')(template.createTime).format('YYYY-MM-DD')}}
        </div>
      </div>
    </div>
    <div class="drawer-footer">
      <Button style="margin-right: 8px" @click="closeDrawer">取消</Button>
      <Button type="primary" style="margin-right: 8px" :disabled="!curTemplate" @click="preview">预览</Button>
      <Button type="warning" :disabled="!curTemplate" @click="confirm">确定签发</Button>
    </div>
    <!-- <Modal v-model="modalTplPreview" title="模板预览" :transfer="false" :styles="{top: '10px'}" width="1024" @on-cancel="previewTplClose">
      <iframe width="100%" height="600" frameborder="0" id="tplPreview"></iframe>
      <div slot="footer">
        <Button type="warning" @click="confirm">确定签发</Button>
        <Button @click="previewTplClose">取消</Button>
      </div>
    </Modal> -->
    <HtmlPreviewModal
      :show="modalTplPreview"
      :content="previewData"
      @close-modal="previewTplClose"
    />
  </Drawer>
</template>

<script>
import HtmlPreviewModal from './HtmlPreviewerModal.vue'

export default {
  name: 'template-list',
  props: {
    show: Boolean,
    guaranteeModel: Object
  },
  components: {
    HtmlPreviewModal
  },
  data () {
    return {
      showDrawer: false,
      curTemplate: null,
      filterModel: {
        pageIndex: 1,
        pageSize: 20,
        sort: null,
        ascending: false
      },
      data: [],
      pageSize: 10,
      totalCount: 0,
      currentPageIndex: 1,
      modalTplPreview: false,
      previewData: null
    }
  },
  watch: {
    show: function (newVal) {
      this.showDrawer = newVal
      if (newVal) {
        this.initData()
      }
    },
    currentPageIndex: function (newVal) {
      if (newVal) {
        this.initData()
      }
    },
    pageSize: function (newVal) {
      if (newVal) {
        this.initData()
      }
    }
  },
  mounted () {
    this.showDrawer = this.show
    if (this.show) {
      this.initData()
    }
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    refresh () {
      // console.log('123')
      this.initData()
    },
    changePageSize (e) {
      this.pageSize = e
    },
    changePageIndex (e) {
      this.currentPageIndex = e
    },
    tableSortChange (e) {
      if (e.key) {
        this.filterModel.sortBy = e.column.sortKey || e.key
        this.filterModel.ascending = e.order === 'normal' ? null : e.order == 'asc' ? true : false
        this.initData()
      }
    },
    cursorTemplate (template) {
      this.curTemplate === template ? this.curTemplate = null : this.curTemplate = template
    },
    async initData () {
      this.$Spin.show()
      if (this.guaranteeModel && this.guaranteeModel.variety) {
        this.filterModel.variety = this.guaranteeModel.variety
      }
      let res = await this.$Api.GuaranteeTemplate.listAvaliableGuaranteeTemplates(this.filterModel, this.currentPageIndex, this.pageSize).catch(err => {
        this.$Message.error(err.message)
        this.$Spin.hide()
      })
      this.totalCount = res.totalCount
      this.currentPageIndex = res.currentPage
      this.pageSize = res.pageSize
      this.data = res.data
      this.$Spin.hide()
    },
    preview () {
      if (!this.curTemplate) {
        this.$Message.error('预览失败!')
      }
      let templateId = this.curTemplate.id
      this.$Api.GuaranteeTemplate.getGuaranteeTemplateDetail(templateId).then((res) => {
        Object.assign(this.curTemplate, res)
        let tpl = this.preparePreviewContent(this.curTemplate.template, this.guaranteeModel)
        this.previewData = tpl
        // document.getElementById('tplPreview').contentWindow.document.write(tpl)
        // document.getElementById('tplPreview').contentWindow.document.close()
        this.modalTplPreview = true
      }).catch(err => {
        this.$Message.error('获取详情失败!' + err.message)
      })
    },
    preparePreviewContent (template, guarantee) {
      let amount = guarantee.amount
      if (guarantee.jointGuarantors && guarantee.jointGuarantors instanceof Array) {
        guarantee.jointGuarantors.forEach((j) => {
          amount += j.amount
        })
      }
      let dic = {
        $NUMBER$: guarantee.orderNumber,
        $BENEFICIARY$: guarantee.beneficiary,
        $BENEFICIARYLICENSE$: guarantee.beneficiaryBusinessLicense || '/',
        $BENEFICIARYADDRESS$: guarantee.beneficiaryAddress || '/',
        $GUARANTEED$: guarantee.guaranteed,
        $GUARANTEEDLICENSE$: guarantee.guaranteedBusinessLicense || '/',
        $GUARANTEEDADDRESS$: guarantee.guaranteedAddress || '/',
        $STARTDATE$: guarantee.gStartDate ? require('moment')(guarantee.gStartDate).format('YYYY-MM-DD HH:mm:ss') : '/',
        $ENDDATE$: guarantee.gEndDate ? require('moment')(guarantee.gEndDate).format('YYYY-MM-DD HH:mm:ss') : '/',
        $CONTRACTSIGNDATE$: guarantee.contractorContractSignDate ? require('moment')(guarantee.contractorContractSignDate).format('YYYY-MM-DD') : '/',
        $PROJECT$: guarantee.project.name,
        $PROJECTNUMBER$: guarantee.project.constrLicenceNo || '/',
        $GUARANTOR$: guarantee.guarantor.name,
        $GUARANTORTEL$: guarantee.guarantor.contactTel,
        $GUARANTORADDRESS$: guarantee.guarantor.address || '/',
        $amount$: Math.round(amount) / 100,
        $AMOUNT$: require('./../utils/common').transformNumberIntoCHS(Math.round(amount) / 100),
        $GUARANTEEDRATIO$: guarantee.amountCostRatio * 100 + '%',
        $RATE$: guarantee.gFeeRate + '%',
        $year$: new Date().getFullYear(),
        $month$: new Date().getMonth() + 1,
        $day$: new Date().getDate()
      }
      for (let p in dic) {
        let key = p.replace(/\$/g, '\\$')
        template = template.replace(RegExp(`${key}`, 'g'), dic[p])
      }
      return template
    },
    previewTplClose () {
      this.previewData = null
      this.modalTplPreview = false
    },
    confirm () {
      this.$Modal.confirm({
        title: '确认操作',
        content: '<p>确认签发么？</p>',
        onOk: async () => {
          this.$emit('on-confirm', this.curTemplate.id)
          this.closeDrawer()
        }
      })
    },
    closeDrawer () {
      this.$emit('on-close-drawer')
    }
  }
}
</script>

<style lang="less" scoped>
.pager {
  margin: 20px 0;
}
.template-item {
  cursor: pointer;
  border: 1px solid #eee;
  border-radius: 5px;
  padding: 10px;
  transition: all .2s linear;
  &.cur {
    border: 2px solid #3098ff;
  }
}
.drawer-footer{
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>
